<template>
        <div class="module module-info">
            <h1 class="title--m mb-4">3 OPERACIONES REALIZADAS SOBRE EL DISPOSITIVO</h1>
            <template v-if="tieneOperaciones">
                <v-simple-table class="operation-table col-6 mt-2">
                    <thead>
                        <tr>
                            <th class="text-left title--xs">Operacion</th>
                            <th class="text-left title--xs">Repuesto</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="op in getOperaciones" :key="op.OPERACION">
                            <td>{{ op.OPERACION }}</td>
                            <td>{{ op.REPUESTO }}</td>
                        </tr>
                    </tbody>
                </v-simple-table>
            </template>
            <template v-else>
                <v-alert class="alert-warning" type="warning" outlined>
                    El dispositivo no tiene operaciones asociadas
                </v-alert>
            </template>
        </div>
</template>

<script>
    export default {
        computed: {
            tieneOperaciones() {
                return this.$bus.pConsulta.datosOrden.OPERACIONES.length > 0
            },
            getOperaciones() {
                return this.$bus.pConsulta.datosOrden.OPERACIONES
            }
        },
  }
</script>
<style lang="scss">
    .v-data-table table th, .operation-table table th{
        font-size: 22px ; 
    }
    .v-data-table table td, .operation-table table td{
        font-size: 18px ; 
        text-align: center;
        padding: 2%;
    }
    .alert-warning{
        color: #9be51a !important;
    }
</style>